// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"113":"630fc102","713":"d2ab872f"}[chunkId] + ".js";
};